export const APP_STAGES = ["Application Received", "Under Review", "Shortlisted", "Interview", "Selected", "Offer", "Completed"];
export const ADMIN_STAGES = ["Application Received", "Under Review", "Shortlisted", "Interview", "Selected", "Offer", "Work Pass Processing", "Completed", "Rejected"];

export const STATUS_COLORS = {
  // applications
  Applied: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  "Application Received": "bg-blue-500/15 text-blue-300 border-blue-500/30",
  "Under Review": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Shortlisted: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  Screening: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Interview: "bg-violet-500/15 text-violet-300 border-violet-500/30",
  Selected: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  Offer: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  "Work Pass Processing": "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
  Onboarding: "bg-teal-500/15 text-teal-300 border-teal-500/30",
  Completed: "bg-teal-500/15 text-teal-300 border-teal-500/30",
  Rejected: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  // inquiries
  new: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  reviewing: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  confirmed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  declined: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  // offers
  Draft: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  Generated: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Sent: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  Accepted: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  Withdrawn: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  Cancelled: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  // compliance
  pending: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  in_progress: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  complete: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  failed: "bg-rose-500/15 text-rose-300 border-rose-500/30",
};

export const DOC_TYPES = ["Passport", "Resume / CV", "Hospitality Certification", "Reference Letter", "Other"];
